import { GuardResult, MaybeAsync } from '@angular/router';
import { from, isObservable, Observable, of } from 'rxjs';

export const maybeAsyncToObservable = (input: MaybeAsync<GuardResult>): Observable<GuardResult> => {
  if (isObservable(input)) {
    return input;
  }
  if (input instanceof Promise) {
    return from(input);
  }
  return of(input);
};
